import { Button } from "@svea/design-system-components-react";
import type { FormFile } from "./file-input";
import { Preview } from "./preview";

const GetPreviewForFile = ({ file }: { file: FormFile }) => {
	switch (file.originalFile?.type) {
		case "application/pdf":
			return <Preview file={file.originalFile} />;
		default:
			return null;
	}
};

export const FileBox = ({
	file,
	fetcher,
	onDelete,
}: {
	file: FormFile;
	fetcher?: () => Promise<Blob>;
	onDelete?: () => void;
}) => {
	return (
		<div className="flex flex-row items-center gap-2" key={file.name}>
			<span>{file.name}</span>

			{file.originalFile ? (
				<GetPreviewForFile file={file} />
			) : fetcher ? (
				<Preview fileFetcher={fetcher} />
			) : null}
			{onDelete && <Button aria-label="icon" icon="trash" onPress={onDelete} variant="icon" />}
		</div>
	);
};
